:host {
  --grid-template-areas: var(
      --stzh-contact-grid-template-areas,
      "heading heading heading heading" "image image image image" "info info info info" "availability availability availability availability" "additional additional additional additional"
  );

  --grid-template-columns: var(
      --stzh-contact-grid-template-columns,
      #{$gridColumns}
  );

  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-contact-grid-template-areas,
        "heading heading heading heading heading heading heading heading" "image image image image . . . ." "info info info info availability availability availability availability" "additional additional additional additional additional additional additional additional"
    );

    --grid-template-columns: var(
        --stzh-contact-grid-template-columns,
        #{$gridColumnsMedium}
    );
  }

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  ::slotted([slot="image"]) {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &[has-availability="false"] {
    @include mq($from: medium) {
      --grid-template-areas: var(
          --stzh-contact-grid-template-areas,
          "heading heading heading heading heading heading heading heading" "image image image image . . . ." "info info info info info info info info" "additional additional additional additional additional additional additional additional"
      );
    }
  }
}

:host[image-position=left] {
  --grid-template-areas: var(
      --stzh-contact-grid-template-areas,
      "heading heading heading heading" "image image image image" "info info info info" "availability availability availability availability" "additional additional additional additional"
  );

  --grid-template-columns: var(
      --stzh-contact-grid-template-columns,
      #{$gridColumns}
  );

  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-contact-grid-template-areas,
        "heading heading heading heading heading heading heading heading" "image info info info availability availability availability availability" "additional additional additional additional additional additional additional additional"
    );

    --grid-template-columns: var(
        --stzh-contact-grid-template-columns,
        auto repeat(7, minmax(0, 1fr))
    );
  }

  @include mq($from: large) {
    --grid-template-areas: var(
        --stzh-contact-grid-template-areas,
        "heading heading heading heading heading heading heading heading heading heading heading heading" "image info info info info info availability availability availability availability availability availability" "additional additional additional additional additional additional additional additional additional additional additional additional"
    );

    --grid-template-columns: var(
        --stzh-contact-grid-template-columns,
        auto repeat(11, minmax(0, 1fr))
    );
  }
}

.stzh-contact {
  @include fontCurve('p1');
  @include gridGutter;
  display: grid;
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);

  &__main-heading {
    grid-area: heading;

    &:not(:empty) {
      @include spaceCurve('margin-bottom', 'tiny');
    }
  }

  &__image-wrapper {
    grid-area: image;
    background-color: $colorSecondary20;
  }

  &__image {
    position: relative;
  }

  &__info {
    grid-area: info;
  }

  &__heading,
  &__name,
  &__address,
  &__numbers,
  &__emails,
  &__pobox,
  &__availability-title {
    &:not(:empty):not(:last-child) {
      margin-bottom: space('xsmall');
    }
  }

  &__numbers {
    white-space: nowrap;
  }

  &__number,
  &__email {
    display: flex;
    align-items: center;
  }

  &__heading,
  &__name,
  &__availability-title {
    @include fontCurve('p1');
    margin: 0px;
  }

  &__heading,
  &__name.is-heading,
  &__availability-title {
    @include font('heavy');
  }

  &__availability {
    grid-area: availability;
    margin-top: space('xlarge');

    @include mq($from: medium) {
      margin-top: 0px;
    }
  }

  &__availability-list,
  &__availability-hour-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__availability-list {
    @include spaceCurve('gap', 'tiny');
    display: grid;
  }

  &__availability-weekday {
    @include fontCurve('p2');
  }

  &__availability-hours {
    display: flex;
    flex-wrap: wrap;
    column-gap: space('xsmall');
  }

  &__availability-hours-separator {
    width: 1px;
    background-color: currentColor;
    flex-shrink: 0;
  }

  &__additional {
    @include spaceCurve('gap', 'regular');
    grid-area: additional;
    display: grid;

    &:not(:empty) {
      margin-top: space('medium');
    }
  }

  /* Has image */

  &--has-image &__image-wrapper {
    margin-bottom: space('medium');
  }

  &--has-image &__image {
    width: 64px;
    height: 64px;

    @include mq($from: small) {
      width: 80px;
      height: 80px;
    }

    @include mq($from: medium) {
      width: 100px;
      height: 100px;
    }

    @include mq($from: large) {
      width: 120px;
      height: 120px;
    }

    @include mq($from: ultra) {
      width: 140px;
      height: 140px;
    }
  }

  /* image position left */
  &--image-position-left &__image-wrapper {
    background-color: transparent;
  }
}
